module.exports = __webpack_public_path__ + "f7447151757df4d90b62c27374ecfc9e.png";